import { PAGE_TYPES } from "../utils/pageTypes";
import { getValue, getBrand } from '../utils/ConfigProvider'
import getDefaultSort from "../utils/defaultSort";

const brand = getBrand()
const enableSortbyNew = getValue('features.productList.enableSortbyNew')

const config = {
  basePath: '',
  home: 'https://www.argos.co.uk',
  domain: 'www.argos.co.uk',
  xhrPath: '/finder-api', // Path for XHR to be served from
  xhrTimeout: 5000,
  httpStatusCodes: {
    success: 200,
    serverError: 500,
    serviceUnavailable: 503,
    notFound: 404,
    permanentRedirect: 301,
    temporaryRedirect: 302
  },
  getProductPath: (partNumber) => {
    return `product/${partNumber}`
  },
  globalFilterIds: ['fasttrack', 'price', 'customer rating'],
  dfp: {
    channelId: 42685526,
    enabled: true
  }
}

const getSortByNewValues = (isBrowse = false, categoryId = undefined) => ({
  'key': 'newness_desc',
  'value': {
    'type': 'newness',
    'order': 'desc'
  },
  'label': (brand === 'tu') ? 'New Arrivals' : 'New in',
  'path': getDefaultSort(!isBrowse, isBrowse, categoryId) === 'newness' ? '' : 'sort:new-arrivals'
})

const sortByValues = [{
  'key': 'price_asc',
  'value': {
    'type': 'price',
    'order': 'asc'
  },
  'label': 'Price: Low - High',
  'path': 'sort:price'
}, {
  'key': 'price_desc',
  'value': {
    'type': 'price',
    'order': 'desc'
  },
  'label': 'Price: High - Low',
  'path': 'sort:price:desc'
}, {
  'key': 'customer rating_desc',
  'value': {
    'type': 'customer rating',
    'order': 'desc'
  },
  'label': 'Customer Rating',
  'path': 'sort:customer-rating'
}]

config.searchSortByValues = [
  {
    'key': 'relevance_desc',
    'value': {
      'type': 'relevance',
      'order': 'desc'
    },
    'label': 'Relevance',
    'path': getDefaultSort(true, false) === 'newness' ? 'sort:relevance:desc' : ''
  },
  ...sortByValues,
  ...(enableSortbyNew ? [getSortByNewValues()] : [])
]

config.browseSortByValues = (categoryId) => {
  const browseSortByValues = [
    {
      'key': 'relevance_desc',
      'value': {
        'type': 'relevance',
        'order': 'desc'
      },
      'label': 'Relevance',
      'path': getDefaultSort(false, true, categoryId) === 'newness' ? 'sort:relevance:desc' : ''
    },
    ...sortByValues,
  ]

  if (enableSortbyNew) {
    // Add newness filter to top of sort options if it is the default
    if (brand === 'tu' && getDefaultSort(false, true, categoryId) === 'newness') {
      browseSortByValues.unshift(getSortByNewValues(true, categoryId))
    } else {
      // Add newness filter to bottom of sort options if not the default
      browseSortByValues.push(getSortByNewValues(true, categoryId))
    }
  }

  return browseSortByValues
}

const categoryTypes = {
  PLP: 'PLP',
  CLP: 'CLP',
  PLPPLUS: 'PLPPLUS',
  SUBHEADING: 'SUBHEADING',
  TOPLEVELCATEGORY: 'TOPLEVELCATEGORY',
  MASTERCATEGORY: 'MASTERCATEGORY'
}

const contentAreaTypes = {
  GridLayoutThree: 'GL003',
  NavigationComponent: 'M012',
  ContentInList: 'M053'
}

const contentAreaIds = {
  AreaA: 'A',
  SeoArea: 'SEO',
  Dfp: {
    top: 'DFPTOP',
    bottom: 'DFPBOTTOM'
  },
  ContentInListArea: 'G'
}

const seoMetaPlaceholders = {
  category: '{{cat}}',
  refinement: '{{ref}}',
  brand: '{{brand}}',
  categoryFallback: '{{cat}} | {{brand}}',
  categoryRefinedFallback: '{{ref}} {{cat}} | {{brand}}'
}

const searchTypes = {
  brandsNIC: 'nic',
  didYouMean: 'dym',
  spellChecked: 'sc',
  NRS: 'nrs'
}

config.adSense = {
  stopWords: ['our', 'best', 'deals', 'on', 'for', 'fantastic', 'offers', 'at', 'argos', 'under', 'shop', 'savings', 'great', 'all', 'shop', 'day', 'amazing', 'seven', 'stock', 'limited', 'selected', 'home and garden', 'Technology', 'pounds', '2 for', 'sports and leisure', 'Jewellery and watches', 'Health and beauty', 'see', 'wow', 'under', 'beginner'],
  browse: {
    enabled: true,
    elementId: 'adsense-footer',
    channelId: {
      desktop: {
        SLP: 6768544131,
        noResults: 7386168737
      },
      mobile: {
        SLP: 4222615939,
        noResults: 8862901932
      }
    },
    advertCount: {
      mobile: {
        noResults: 3,
        hasResults: 2
      },
      desktop: 3
    },
    pubId: 'pub-2476674212740568'
  },
  search: {
    enabled: true,
    elementId: 'adsense-footer',
    channelId: {
      desktop: {
        SLP: 8745955930,
        noResults: 7386168737
      },
      mobile: {
        SLP: 7269222731,
        noResults: 8862901932
      }
    },
    advertCount: {
      mobile: {
        noResults: 3,
        hasResults: 2
      },
      desktop: 3
    },
    pubId: 'pub-2476674212740568'
  }
}

const availabilityExclusions = [
  // Rings
  '/browse/jewellery-and-watches/womens-jewellery/womens-rings/c:29317',
  '/browse/jewellery-and-watches/mens-jewellery/mens-rings/c:29330',
  '/list/shop-for-engagement-rings',
  '/list/shop-for-engagement-and-bridal',
  '/list/shop-all-rings-at-argos',
  '/list/shop-all-jewellery-at-argos',
  '/list/shop-for-mens-wedding-rings',
  '/search/rings',
  '/search/engagement-ring/',
  '/search/ring',
  '/search/wedding-ring',
  '/search/mens-rings'
]

const citrusRestrictedPages = [
  PAGE_TYPES.CANNED
]

export {
  categoryTypes,
  contentAreaTypes,
  contentAreaIds,
  seoMetaPlaceholders,
  searchTypes,
  availabilityExclusions,
  citrusRestrictedPages
}
export default config
